(function () {
  const desktopQuery = window.matchMedia("(min-width: 990px)");
  let contentCount = 0;

  // Below the desktop layout the heading is the accordion toggle, so it becomes a
  // keyboard button there; on desktop it is a plain heading again and leaves the tab
  // order.
  const syncToggle = (summary, details, content) => {
    if (desktopQuery.matches) {
      ["role", "tabindex", "aria-expanded", "aria-controls"].forEach((name) =>
        summary.removeAttribute(name)
      );
      return;
    }
    if (!content.id) content.id = `FooterMenuContent-${++contentCount}`;
    summary.setAttribute("role", "button");
    summary.setAttribute("tabindex", "0");
    summary.setAttribute("aria-controls", content.id);
    summary.setAttribute(
      "aria-expanded",
      details.getAttribute("open") ? "true" : "false"
    );
  };

  const initMobileMenu = (footer) => {
    footer.querySelectorAll(".js-accordion-mobile").forEach((details) => {
      const summary = details.querySelector(".footer__nav-heading");
      const content = details.querySelector(".footer__nav-content");
      let isAnimating = false;

      if (!summary || !content) return;
      syncToggle(summary, details, content);
      // section reorder re-runs init on the same nodes
      if (details.dataset.accordionInit === "true") return;
      details.dataset.accordionInit = "true";

      summary.addEventListener("keydown", (event) => {
        if (desktopQuery.matches) return;
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        summary.click();
      });

      summary.addEventListener("click", (event) => {
        if (window.innerWidth >= 990 || isAnimating) {
          return;
        }

        event.preventDefault();

        isAnimating = true;

        if (!details.getAttribute("open")) {
          const contentHeight = content.scrollHeight;
          content.style.setProperty(
            "--footer-menu-max-height",
            `${contentHeight}px`
          );

          details.setAttribute("open", true);

          content.addEventListener(
            "transitionend",
            () => {
              isAnimating = false;
            },
            { once: true }
          );
        } else {
          details.removeAttribute("open");

          content.addEventListener(
            "transitionend",
            () => {
              isAnimating = false;
            },
            { once: true }
          );
        }
        summary.setAttribute(
          "aria-expanded",
          details.getAttribute("open") ? "true" : "false"
        );
      });
    });
  };

  const initFooter = () => {
    const footer = document.querySelector(".shopify-section-footer");
    if (!footer) return;

    initMobileMenu(footer);
  };

  initFooter();

  desktopQuery.addEventListener("change", initFooter);
  document.addEventListener("shopify:section:load", initFooter);
  document.addEventListener("shopify:section:unload", initFooter);
  document.addEventListener("shopify:section:reorder", initFooter);
})();
